import { Selector, State } from "./types";
import { projectDetailsConfiguration } from "@planzone/dto";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveProjectDetailsConfigurationRequestFailure({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRetrieveProjectDetailsConfigurationRequestPending({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRetrieveProjectDetailsConfigurationRequestSuccess({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
    getProjectDetailsConfiguration({ uuid }) {
      const req = getState().find(({ planzone }) => planzone.uuid === uuid);

      return req ? req.configuration : projectDetailsConfiguration;
    },
  };
}

export { createSelector };
